<app-hero title="Common Questions and Answers"
          subtitle="Common questions on how the events work, options, and other questions regarding the entire team building experience."
          primaryCtaLabel="Categories"
          primaryCtaLink="/q-and-a"
          primaryCtaFragment="categories"
          secondaryCtaLabel="Contact Us"
          secondaryCtaLink="/contact-us">
</app-hero>

<app-layout-container>
  <section id="categories" class="qa-categories">
    <app-section-heading [animateTitle]="true"
                         animateTitleTrigger="in-view"
                         eyebrow="Categories"
                         title="Common Questions"
                         text="United Team Building has provided categories for common questions with answers. Questions concerning options, packages and support are listed below. Please feel free to reach out by contacting us concerning any needs or questions.">
    </app-section-heading>

    <div class="qa-category-buttons">
      @for (category of categoryButtons; track category.id) {
      <a class="qa-category-button"
         [attr.href]="'#' + category.id"
         (click)="scrollToCategory($event, category.id)">{{ category.label }}</a>
      }
    </div>
  </section>
</app-layout-container>

<app-layout-container>
  <section id="questions" class="qa-content">
    <div class="qa-content__questions">
      @for (category of questionCategories; track category.id) {
      <article [id]="category.id" class="qa-category-group">
        <header class="qa-category-group__header">
          <h3>{{ category.title }}</h3>
        </header>

        <div class="qa-question-list" (click)="onAnswerLinkClick($event)">
          @for (question of category.questions; track question.id) {
          <div class="qa-question-item"
               [attr.id]="question.id"
               (click)="onQuestionItemClick(question, $event)">
            <div class="qa-question-row">
              <p class="qa-question-text">{{ question.question }}</p>
              <button type="button"
                      class="qa-toggle"
                      [attr.aria-expanded]="isExpanded(question.id)"
                      (click)="toggleQuestion(question); $event.stopPropagation()">
                {{ isExpanded(question.id) ? '−' : '+' }}
              </button>
            </div>

            @if (isExpanded(question.id)) {
            <p class="qa-answer-text" [innerHTML]="question.answerHtml ?? question.answer"></p>
            @if (question.imageSrc) {
            <img class="qa-answer-image" [src]="question.imageSrc" [alt]="question.imageAlt ?? 'United Team Building question image'" />
            }
            @if (question.siteLinkUrl) {
            <a class="qa-answer-site-link" [attr.href]="question.siteLinkUrl">{{ question.siteLinkLabel ?? 'More Info' }}</a>
            }
            }
          </div>
          }
        </div>
      </article>
      }
    </div>
  </section>
</app-layout-container>
